// Cells shared by the two Assistant Config views (per-namespace rows and per-cluster
// defaults), so cluster links, chart-version markers and the filter row render the same.
import type { DefaultsSource } from "../api/types";

export function FilterCell({ col, value, onChange }: { col: string; value: string; onChange: (col: string, val: string) => void }) {
    return (
        <th>
            <input
                placeholder="filter…"
                value={value}
                onChange={(e) => onChange(col, e.target.value)}
                onClick={(e) => e.stopPropagation()}
            />
        </th>
    );
}

/** Cluster name linking to the cluster's app_clusters values.yaml when the repo has one. */
export function ClusterLink({ cluster, url }: { cluster: string; url?: string }) {
    if (!url) return <strong>{cluster}</strong>;
    return (
        <a className="source-link" href={url} target="_blank" rel="noopener noreferrer" title="cluster values.yaml">
            <strong>{cluster}</strong>
        </a>
    );
}

/** Chart version with its tag-notes link, flagging when defaults did not come from the deployed tag. */
export function ChartVersionCell({
    chartVersion,
    defaultsSource,
    url,
}: {
    chartVersion: string;
    defaultsSource: DefaultsSource;
    url?: string;
}) {
    const marker =
        defaultsSource === "latest" ? (
            <span className="tag-extra" title="deployed chart version unknown — defaults from latest tag">
                {" "}
                latest
            </span>
        ) : defaultsSource === "none" ? (
            <span className="tag-extra" title="no chart defaults resolved">
                {" "}
                no defaults
            </span>
        ) : null;
    return (
        <td className="version">
            {chartVersion ? (
                url ? (
                    <a className="source-link" href={url} target="_blank" rel="noopener noreferrer" title="tag notes">
                        {chartVersion}
                    </a>
                ) : (
                    chartVersion
                )
            ) : (
                "—"
            )}
            {marker}
        </td>
    );
}
